export default __webpack_public_path__ + "static/media/02_DAIF_Services_01.f509f818.mp4";